import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { GridItemStyle } from "@insite/mobius/GridItem";
import Clickable, { StyledButton } from "@insite/mobius/Clickable";
import { getWarehouseData } from "@NA/Services/ADIShopMyBranchService";
import { useState } from "react";
import Link, { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import ChevronUp from "@insite/mobius/Icons/ChevronUp";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";

import { getDeliveryLoc } from "@NA/Services/RequestQuoteServices";
import useMediaQuery from "@NA/Overrides/Common/Hooks/useMediaQuery";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import ADIColors from "@NA/Utils/ADIColors";

interface CustomLocationModel {
    id: string;
    latitude: number;
    longitude: number;
    distance: number;
    hours?: string;
    name: string;
    address1: string;
    address2?: string;
    city: string;
    state: string;
    postalCode: string;
    phone?: string;
    htmlContent?: string;
    properties?: any;
}

interface OwnProps {
    showGeoLocationErrorMessage: boolean;
    geoLocationErrorMessage: React.ReactNode;
    onSearch: (searchGeoLocationFilter: string, searchLocationFilter: string) => void;
    isLoading: boolean;
    geoLocationSearchText: string;
    locationSearchFilter: string;
    extendedStyles?: LocationSearchFormStyles;
    locationKnown: boolean;
    locations: CustomLocationModel[];
    siteMessageResultsErrorMessage: React.ReactNode;
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    settings: getSettingsCollection(state),
    isAuthenticated: state.context.session.isAuthenticated,
});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface LocationSearchFormStyles {
    form?: InjectableCss;
    searchContainer?: InjectableCss;
    searchInputGridContainer: GridContainerProps;
    searchGeoLocationGridItem?: GridItemProps;
    searchGeoLocationText?: TextFieldPresentationProps;
    searchLocationsText?: TextFieldPresentationProps;
    searchLocationsGridItem?: GridItemProps;
    searchButtonGridItem?: GridItemProps;
    searchButton?: ButtonPresentationProps;
    siteMessageGridItem?: GridItemProps;
    siteMessageGeocodeErrorText?: TypographyPresentationProps;
    siteMessageResultsErrorText?: TypographyPresentationProps;
    rightsection?: InjectableCss;
    rightsectionofbranch?: InjectableCss;
    leftsection?: InjectableCss;
    rightsectioninner?: InjectableCss;
    leftsectionparent?: InjectableCss;
    leftsectionee?: InjectableCss;
    branchdetailsheading?: InjectableCss;
    branchHoursHeading?: InjectableCss;
    branchdetailscontent?: InjectableCss;
    branchheading?: InjectableCss;
    postalcodeheading?: InjectableCss;
    searchbuttonstyle?: InjectableCss;
    branchclickable?: InjectableCss;
    leftsectionbranch?: InjectableCss;
    leftsectionhours?: InjectableCss;
    leftsectionphonenum?: InjectableCss;
    leftsectiomanager?: InjectableCss;
    searchbuttondiv?: InjectableCss;
    branchheadingright?: InjectableCss;
    leftsectionunauthsearch?: InjectableCss;
    unauthmaindiv?: InjectableCss;
    rightsectionunauth?: InjectableCss;
    searchheadersectionauth?: InjectableCss;
    searchheadersectionunauth?: InjectableCss;
    postalcodeheadingunauth?: InjectableCss;
    searchbuttondivunauth?: InjectableCss;
    leftsectionphnmanger?: InjectableCss;
    leftsectionbranchhours?: InjectableCss;
    hidedetailsection?: InjectableCss;
    showdetailsparagraph?: InjectableCss;
    leftsectionhoursmobile?: InjectableCss;
    leftsectionhoursdesktop?: InjectableCss;
    branchdetailscontentmobile?: InjectableCss;
    leftsectionphnmangerfornational?: InjectableCss;
    leftsectionbranchhoursnational?: InjectableCss;
    leftsectionbranchnational?: InjectableCss;
    leftsectionbranchnationalbranch?: InjectableCss;
    leftsectionbranchnationalmanager?: InjectableCss;
    leftsectionbranchnationalmanagerbranchclickable?: InjectableCss;
    branchdetailscontentemail?: InjectableCss;
    iconHover?: InjectableCss;
    searchResultPhoneLink?: LinkPresentationProps;
}

export const locationSearchFormStyles: LocationSearchFormStyles = {
    form: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px 5px !important;
                    `,
                    css``,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    searchInputGridContainer: {
        gap: 10,
        css: css`
            .test {
                max-width: 100%;
                flex-basis: 100%;
            }

            display: flex;
            flex-direction: row;

            overflow: visible;
            display: flex;
            flex-direction: row;
            overflow-wrap: break-word;
            word-break: break-word;
            padding: 10px 0px;
            flex-basis: 100%;
            max-width: 100%;
            align-items: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 0px !important;
                        padding-top: 0px !important;
                    `,
                    css`
                        padding-bottom: 0px !important;
                        padding-top: 0px !important;
                    `,
                    css`
                        padding-bottom: 0px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    searchGeoLocationGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            padding-right: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 0px;
                    `,
                    css`
                        padding-right: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    searchLocationsGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            padding-right: 25px;
            label {
                text-transform: unset;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            min-height: 45px;
                        `,
                        null,
                        null,
                    ])}
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 0px;
                    `,
                    css`
                        padding-right: 0px;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    searchButtonGridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
            align-items: flex-end;
            > button {
                display: flex;
                border-radius: 4px;
                width: 100%;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                font-weight: bold;
                min-width: 100px;
                &:focus {
                    outline: none;
                }
            }
        `,
    },
    siteMessageGridItem: {
        width: 12,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        padding: 0px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    siteMessageGeocodeErrorText: {
        color: "danger",
        weight: "bold",
    },
    siteMessageResultsErrorText: {
        color: "danger",
        weight: "bold",
    },
    leftsection: {
        css: css`
            display: block;
            flex-basis: 25%;
            max-width: 25%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        order: 2;
                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionee: {
        css: css`
            flex-basis: 75% !important;
            max-width: 75% !important;
            display: block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                        margin-top: 0px !important;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    css`
                        text-align: center;
                        margin-top: 0px !important;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    css`
                        text-align: center;
                        padding-top: 0px !important;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        margin-top: 9px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },

    leftsectionunauthsearch: {
        css: css`
            flex-basis: 25.999997% !important;
            max-width: 25.999997% !important;
            margin-top: 53px !important;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        display: inline-block;
                    `,
                    css`
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        display: inline-block;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    rightsectionofbranch: {
        css: css`
            ${GridItemStyle} {
            }
        `,
    },
    rightsectioninner: {
        css: css`
            display: block;
        `,
    },
    leftsectionparent: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            padding: 4px 10px 15px 10px;
            border-radius: 4px;
            background-color: #f2f2f2;
            margin-top: 15px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 15px !important;
                        margin-bottom: 15px !important;
                        display: flex;
                        flex-direction: column;
                    `,
                    css`
                        display: flex;
                        margin-top: 15px !important;
                        margin-bottom: 15px !important;
                        height: auto;
                    `,
                    css`
                        display: block !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    searchContainer: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    branchdetailsheading: {
        css: css`
            font-size: 16px !important;
            font-weight: bold;
            padding-bottom: 5px;
            font-style: normal;
            line-height: normal;
            text-align: left;
            color: ${ADIColors.darkBlack3};
            display: block;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            float: left;
                            width: 100%;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    branchHoursHeading: {
        css: css`
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 5px;
            font-style: normal;
            line-height: normal;
            text-align: left;
            color: ${ADIColors.darkBlack3};
            display: block;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            float: left;
                            width: 100%;
                            padding-top: 10px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    branchdetailscontent: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            text-align: left;
            color: ${ADIColors.darkBlack3};
            display: block;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            float: left;
                            width: 100%;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    branchheading: {
        css: css`
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #002856;
            padding-bottom: 15px;
            display: block;
            @media (min-width: 768px) and (max-width: 1079px) {
                text-align: center;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    branchheadingright: {
        css: css`
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: #002856;
            padding-bottom: 15px;
        `,
    },
    postalcodeheading: {
        css: css`
            font-size: 14px;
            font-family: "Nunito Sans", sans-serif;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: ${ADIColors.darkBlack3};
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px !important;
            margin-bottom: 15px;
            .FormInputWrapper-sc-5bfmal input::placeholder {
                color: #2d2926;
            }
            input {
                height: 38px !important;
                min-height: 38px !important;

                @media only screen and (min-width: 1080px) {
                    margin-bottom: 15px;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 15px !important;
                    `,
                    css`
                        margin-bottom: 15px !important;
                        max-width: 70%;
                        flex-basis: 70%;
                        display: inline-block;
                    `,
                    css`
                        max-width: 70%;
                        flex-basis: 70%;
                        margin-bottom: 0px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    postalcodeheadingunauth: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: ${ADIColors.darkBlack3};
            flex-basis: 25.883333%;
            max-width: 25.883333%;
            padding: 0px 20px 0px 0px !important;
            margin-bottom: 15px;

            input {
                height: 38px !important;
                min-height: 38px;
            }
            .FormInputWrapper-sc-5bfmal input::placeholder {
                color: #2d2926;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 15px !important;
                        max-width: 100%;
                        flex-basis: 100%;
                        padding: 0px !important;
                    `,
                    css`
                        margin-bottom: 15px !important;
                        max-width: 70%;
                        flex-basis: 70%;
                        display: inline-block;
                        padding: 0px !important;
                    `,
                    css`
                        margin-bottom: 15px !important;
                        max-width: 70%;
                        flex-basis: 70%;
                        display: inline-block;
                        padding: 0px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    searchbuttondiv: {
        css: css`
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
            max-width: 100%;
            height: 38px;
            flex-grow: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 10px;

            padding: 0px;
            @media (min-width: 768px) and (max-width: 1079px) {
                padding: 0px 0px 0px 0px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px;
                    `,
                    css`
                        max-width: 30%;
                        flex-basis: 30%;
                        display: inline-block;
                        padding: 0px;
                    `,
                    css`
                        max-width: 30%;
                        flex-basis: 30%;

                        margin-left: 20px !important;
                        margin-top: 25px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    searchbuttondivunauth: {
        css: css`
            width: 100%;
            max-width: 100%;
            flex-basis: 24.8833%;
            max-width: 24.8833%;
            flex-grow: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 10px;
            padding: 10px;
            @media (min-width: 1080px) {
                padding: 10px 0px;
            }
            margin-top: 27px !important;
            margin-left: 20px;
            height: 38px;
            min-height: 38px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-top: 15px !important;
                        padding: 0px !important;
                    `,
                    css`
                        max-width: 30%;
                        flex-basis: 30%;
                        display: inline-block;

                        margin-top: 15px !important;
                        padding: 15px;
                    `,
                    css`
                        max-width: 30%;
                        flex-basis: 30%;
                        margin-left: 20px !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    searchbuttonstyle: {
        css: css`
            width: 100%;
            flex-grow: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 10px;
            padding: 10px;
            height: 38px;
            min-height: 38px;
            border-radius: 4px;
            background-color: #006ae3;
            &:hover {
                width: 100%;
                text-align: center;
                background: #006ae3 !important;
                border: 2px solid #006ae3 !important;
            }
        `,
    },

    branchclickable: {
        css: css`
            font-weight: bold;
            color: #006ae3;
            font-size: 14px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        float: left;
                    `,
                    css`
                        float: left;
                    `,
                    css`
                        text-align: left;
                        width: 100%;
                        display: block;
                    `,

                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionbranchnationalmanagerbranchclickable: {
        css: css`
            font-weight: bold;
            color: #006ae3;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        float: left;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    hidedetailsection: {
        css: css`
            font-weight: bold;
            color: #006ae3;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    css`
                        display: block;
                    `,
                    css`
                        display: block;
                    `,
                ])}
        `,
    },
    rightsection: {
        css: css`
            display: block;
            flex-basis: 25% !important;
            max-width: 25% !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        padding-top: 0 !important;
                        // margin-bottom:15px !important;
                    `,
                    css`
                        order: 2;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        display: inline-block;
                        padding-top: 0 !important;
                    `,
                    css`
                        order: 2;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        display: inline-block;
                        padding-top: 29px;
                        padding-bottom: 0px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    rightsectionunauth: {
        css: css`
            display: block;
            flex-basis: 27.333333% !important;
            max-width: 27.333333% !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    css`
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                        display: inline-block;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },

    leftsectionbranch: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;
            border-right: 1px solid #ddd;
            height: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100%;
                        max-width: 100%;
                        border-right: none;
                    `,
                    css`
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        float: left;
                        border-right: none;
                    `,
                    css`
                        order: 2;
                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        clear: both;
                        padding-left: 0px;
                        padding-left: 10px;
                        padding-left: 10px !important;
                        border-right: none;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionhoursdesktop: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;
            border-right: 1px solid #ddd;
            padding-left: 10px;
            height: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100%;
                        max-width: 100%;
                        padding-left: 0px;
                        display: none;
                    `,
                    css`
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        clear: both;
                        padding-left: 0px;
                        border-left: 1px solid #ddd;
                        padding-left: 10px;
                        padding-left: 10px !important;
                        border-right: none;
                    `,
                    css`
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        clear: both;
                        padding-left: 0px;
                        border-left: 1px solid #ddd;
                        padding-left: 10px;
                        padding-left: 10px !important;
                        border-right: none;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionphonenum: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;
            border-right: 1px solid #ddd;
            //padding-left: 10px;
            padding-left: 0px;
            height: 100px;

             ${TypographyStyle} {
                font-size: 14px;
            }
             ${StyledButton} {
                > ${TypographyStyle} {
                    color: ${getColor("text.main")};
                    &:hover {
                        color: ${getColor("primary")};
                    }
                }
            }
            
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100%;
                        max-width: 100%;
                        padding-left: 4px;
                        border-right: none;
                        height: auto;
                    `,
                    css`
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;

                        clear: both;
                        padding-left: 4px;
                        border-right: none;
                        height: auto;
                    `,
                    css`
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        clear: both;
                        padding-left: 0px;

                        padding-left: 10px;
                        padding-left: 10px !important;
                        border-right: none;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectiomanager: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;

            padding-left: 10px;
            height: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100%;
                        max-width: 100%;
                        padding-left: 4px;
                    `,
                    css`
                        padding-left: 4px;
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        position: relative;
                        bottom: 120px;
                        left: 44px;

                        border-left: 1px solid #ddd;
                        padding-left: 10px;
                        padding-left: 10px !important;
                    `,
                    css`
                        order: 2;

                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        clear: both;
                        padding-left: 0px;
                        border-left: 1px solid #ddd;
                        padding-left: 10px;
                        padding-left: 10px !important;
                        border-right: none;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },

    unauthmaindiv: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            display: block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        order: 2;
                        padding-top: 0;
                    `,
                    css`
                        display: block;
                        order: 2;
                        padding-top: 0;
                    `,
                    css`
                        order: 2;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },

    searchheadersectionauth: {
        css: css`
            display: block;
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                    `,
                    css`
                        display: flex;
                    `,
                    css`
                        display: flex !important;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    searchheadersectionunauth: {
        css: css`
            overflow: visible;
            display: flex;
            flex-direction: row;
            overflow-wrap: break-word;
            word-break: break-word;
            padding: 0px 0px;
            flex-basis: 100%;
            max-width: 100%;
            align-items: flex-end;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        padding: 0px;
                    `,
                    css`
                        display: flex;
                        padding: 0px;
                    `,
                    css`
                        align-items: initial;
                    `,
                    css`
                        align-items: flex-end;
                    `,
                    css`
                        align-items: flex-end;
                    `,
                ])}
        `,
    },

    leftsectionphnmanger: {
        css: css`
            display: flex;
            flex-basis: 50%;
            max-width: 50%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: block;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: flex;
                    `,
                    css``,
                    css`
                         ;
                    `,
                ])}
        `,
    },
    leftsectionphnmangerfornational: {
        css: css`
            display: flex;
            flex-basis: 0%;
            max-width: 0%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: block;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        flex-direction: column-reverse;
                        border-left: 1px solid #ddd;
                        gap: 29px;
                    }
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: none;
                    `,
                    css``,
                    css`
                         ;
                    `,
                ])}
        `,
    },

    leftsectionbranchhours: {
        css: css`
            display: flex;
            flex-basis: 50%;
            max-width: 50%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: block;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: flex;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionbranchhoursnational: {
        css: css`
            display: flex;
            flex-basis: 100%;
            max-width: 100%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: block;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        display: flex;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionbranchnational: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionbranchnationalmanager: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        border-right: 1px solid #ddd;
                        height: 100px;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    leftsectionbranchnationalbranch: {
        css: css`
            display: block;
            flex-basis: 50%;
            max-width: 50%;
            border-right: 1px solid #ddd;
            height: 100px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                        flex-basis: 100%;
                        max-width: 100%;
                        border-right: none;
                    `,
                    css`
                        order: 2;
                        flex-basis: 50%;
                        max-width: 50%;
                        display: inline-block;
                        float: left;
                        border-right: none;
                    `,
                    css`
                        order: initial;

                        flex-basis: 38%;
                        max-width: 38%;
                        display: inline-block;
                        clear: both;
                        padding-left: 0px;

                        border-right: 1px solid #ddd;
                        padding-left: 10px;
                        padding-left: 10px !important;
                        border-left: none;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    showdetailsparagraph: {
        css: css`
            position: relative;
            left: 23px;

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            left: 104px;
                            float: left;
                            clear: none;
                        `,
                        css`
                            left: 70px;

                            float: left;
                            clear: none;
                        `,
                        css`
                            position: relative;
                            left: 35px;
                        `,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
    leftsectionhoursmobile: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: flex;
                            flex-basis: 100%;
                            max-width: 100%;
                            flex-direction: column;
                            span {
                                display: flex;
                            }
                        `,
                        css`
                            display: flex;
                            flex-basis: 100%;
                            max-width: 100%;
                            flex-direction: column;
                            span {
                                display: flex;
                            }
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                    ],
                )}
        `,
    },
    branchdetailscontentmobile: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                             ;
                        `,
                        css``,
                        css``,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
    branchdetailscontentemail: {
        css: css`
            color: #006ae3 !important;
            font-size: 14px;
            font-weight: 600;
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            float: left;
                        `,
                        css``,
                        css``,
                        css``,
                        css``,
                    ],
                    "min",
                )}
        `,
    },
    iconHover: {
        css: css`
            cursor: pointer;
            font-weight: 600;
        `,
    },

    searchResultPhoneLink: {
        css: css`
            text-decoration: underline;
        `,
    },
};

const defaultBranchInfo = {
    name: "",
    code: "",
    attributeid: "",
    address1: "",
    address2: "",
    phone: "",
    city: "",
    state: "",
    zipCode: "",
    fax: "",
    manager: "",
    hours: "",
    email: "",
};

const StyledForm = getStyledWrapper("form");

const Container = StyledWrapper;

const LocationSearchForm: React.FC<Props> = ({
    showGeoLocationErrorMessage,
    geoLocationErrorMessage,
    onSearch,
    isLoading,
    geoLocationSearchText,
    locationSearchFilter,
    extendedStyles,
    locationKnown,
    locations,
    siteMessageResultsErrorMessage,
    isAuthenticated,
}) => {
    const [isNationalAccount, setIsNationalAccount] = useState<string>("");
    const [searchGeoLocationFilter, setSearchGeoLocationFilter] = React.useState(geoLocationSearchText);
    const [searchLocationFilter, setSearchLocationFilter] = React.useState(locationSearchFilter);
    const [styles] = React.useState(() => mergeToNew(locationSearchFormStyles, extendedStyles));
    const [branchInfo, setBranchInfo] = useState(defaultBranchInfo);
    const [collapsedUsers, setCollapsedusers] = useState(Array(locations.length).fill(true));

    const index = 0;

    React.useEffect(() => {
        if (isAuthenticated) {
            fetchBranchDetails();
        }
    }, []);
    const fetchBranchDetails = async () => {
        const response = await getWarehouseData();

        setBranchInfo(response);
    };

    React.useEffect(() => {
        setSearchLocationFilter(locationSearchFilter);
    }, [locationSearchFilter]);

    React.useEffect(() => {
        setSearchGeoLocationFilter(searchGeoLocationFilter);
    }, [searchGeoLocationFilter]);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isLoading) {
            onSearch(searchGeoLocationFilter, searchLocationFilter);
        }
    };
    const handleSearchGeoLocationChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchGeoLocationFilter(event.target.value);
    };

    React.useEffect(() => {
        const fetchDeliveryLoc = async () => {
            const res = await getDeliveryLoc();
            if (res?.deliveryLocRespHeader) {
                setIsNationalAccount(res?.deliveryLocRespHeader?.nationalAcct);
            } else {
            }
        };

        fetchDeliveryLoc().catch(err => {});
    }, []);

    const [uncollapsedUser, setUnCollapseduser] = useState(-1);
    const isMobile = useMediaQuery("(max-width: 600px)");

    const showdetailssection = (index: number) => {
        if (isMobile) {
            setUnCollapseduser(prevIndex => (prevIndex === index ? -1 : index));
        }
    };

    const capitalizeBranchName = (branchName: string) => {
        return branchName
            .split(" ")
            .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };

    return (
        <StyledForm {...styles.form} onSubmit={handleSubmit} noValidate>
            <Container {...styles.searchContainer}>
                {isAuthenticated ? (
                    <GridContainer {...styles.searchInputGridContainer}>
                        <GridItem {...styles.siteMessageGridItem}>
                            {!isLoading && !locationKnown && geoLocationSearchText.length > 0 && (
                                <Typography {...styles.siteMessageGeocodeErrorText}>
                                    {siteMessage("PickUpLocation_GeocodeErrorMessage")}
                                </Typography>
                            )}
                            {!isLoading && locationKnown && locations.length === 0 && siteMessageResultsErrorMessage && (
                                <Typography
                                    {...styles.siteMessageResultsErrorText}
                                    data-test-selector="locationSearchForm_siteErrorMessage"
                                >
                                    {siteMessageResultsErrorMessage}
                                </Typography>
                            )}
                        </GridItem>

                        <GridItem {...styles.rightsection} width={[12, 12, 4, 4, 4]}>
                            <Typography as="h2" {...styles.branchheading}>
                                {" "}
                                {translate("Search a Branch")}
                            </Typography>
                            <GridItem {...styles.searchheadersectionauth}>
                                <GridItem {...styles.postalcodeheading}>
                                    <TextField
                                        id="dealerLocatorViewAddressSearchField"
                                        label={translate("Zip/Postal Code or City, State/Province or Country")}
                                        required={true}
                                        value={searchGeoLocationFilter}
                                        onChange={handleSearchGeoLocationChanged}
                                        aria-hidden="true"
                                        placeholder={translate("Enter value here...")}
                                        data-test-selector="locationSearchForm_searchGeoLocation"
                                        error={showGeoLocationErrorMessage ? geoLocationErrorMessage : undefined}
                                    />
                                </GridItem>
                                <GridItem {...styles.searchbuttondiv}>
                                    <Button
                                        {...styles.searchbuttonstyle}
                                        type="submit"
                                        data-test-selector="locationSearchForm_searchButton"
                                    >
                                        {translate("Search")}
                                    </Button>
                                </GridItem>
                            </GridItem>
                        </GridItem>

                        <GridItem width={[12, 12, 8, 8, 8]} {...styles.leftsectionee}>
                            <Typography {...styles.branchheadingright}> {translate("My Branch")}</Typography>
                            <GridItem {...styles.leftsectionparent}>
                                <GridItem {...styles.leftsectionbranchhours}>
                                    <GridItem {...styles.leftsectionbranch}>
                                        <Typography {...styles.branchdetailsheading}>
                                            {capitalizeBranchName(branchInfo?.name)} {translate("Branch")}
                                        </Typography>

                                        <Typography {...styles.branchdetailscontent}>
                                            {" "}
                                            {branchInfo?.address1
                                                ?.replace(/[()]/g, "")
                                                .toLowerCase()
                                                .replace(/\b\w/g, char => char.toUpperCase())}
                                        </Typography>

                                        <Typography {...styles.branchdetailscontent}>
                                            {branchInfo?.city
                                                ?.replace(/[()]/g, "")
                                                .toLowerCase()
                                                .replace(/\b\w/g, char => char.toUpperCase())}
                                            , {branchInfo?.state?.trim()} {branchInfo?.zipCode?.trim()}{" "}
                                        </Typography>

                                        <Typography {...styles.branchclickable}>
                                            {branchInfo?.address1 &&
                                                branchInfo?.city &&
                                                branchInfo?.state &&
                                                branchInfo?.zipCode && (
                                                    <Link
                                                        style={{ fontWeight: "bold" }}
                                                        href={`http://maps.google.com/maps?daddr=${branchInfo?.address1} ${branchInfo?.address2}, ${branchInfo?.city}, ${branchInfo?.state} ${branchInfo?.zipCode}`}
                                                        target="_blank"
                                                    >
                                                        {translate("Directions")}
                                                    </Link>
                                                )}
                                        </Typography>

                                        <Typography
                                            as="p"
                                            {...styles.showdetailsparagraph}
                                            onClick={() => showdetailssection(index)}
                                            style={{ cursor: isMobile ? "pointer" : "default" }}
                                        >
                                            {isMobile && uncollapsedUser === index ? (
                                                <Typography {...styles.iconHover}>
                                                    {translate("Hide Details")} <StyledIcon size={24} src={ChevronUp} />
                                                </Typography>
                                            ) : isMobile ? (
                                                <Typography {...styles.iconHover}>
                                                    {translate("Show Details")}{" "}
                                                    <StyledIcon size={24} src={ChevronDown} />
                                                </Typography>
                                            ) : (
                                                <Typography></Typography>
                                            )}
                                        </Typography>
                                    </GridItem>

                                    <GridItem {...styles.leftsectionhoursdesktop}>
                                        <Typography {...styles.branchHoursHeading}> {translate("Hours")}</Typography>

                                        <Typography {...styles.branchdetailscontent}>
                                            {" "}
                                            {translate("Mon-Fri 7:30 a.m. - 5:30 p.m.")}
                                        </Typography>

                                        <Typography {...styles.branchdetailscontent}>
                                            {translate("May vary due to events and holidays.")}{" "}
                                        </Typography>
                                        <Typography {...styles.branchdetailscontent}> </Typography>
                                    </GridItem>
                                </GridItem>

                                {(isMobile && uncollapsedUser === index) || !isMobile ? (
                                    <GridItem {...styles.leftsectionphnmanger}>
                                        <GridItem {...styles.leftsectionhoursmobile}>
                                            <Typography {...styles.branchHoursHeading}>
                                                {" "}
                                                {translate("Hours")}

                                            </Typography>
                                            <Typography {...styles.branchdetailscontentmobile}>
                                                {translate("Mon-Fri 7:30 a.m. - 5:30 p.m.")}
                                            </Typography>
                                            <Typography {...styles.branchdetailscontentmobile}>
                                                {translate("May vary due to events and holidays.")}
                                            </Typography>
                                        </GridItem>

                                        <GridItem {...styles.leftsectionphonenum}>
                                            <Typography {...styles.branchdetailsheading}>
                                                {translate("Store Phone Number")}
                                            </Typography>
                                            <Typography {...styles.branchdetailscontent}>
                                                <Link
                                                    href={`tel:${branchInfo.phone}`}
                                                    {...styles.searchResultPhoneLink}
                                                    target="_blank"
                                                >
                                                    {translate(branchInfo.phone.replace(/-/g, "."))}
                                                </Link>
                                            </Typography>
                                        </GridItem>

                                        <GridItem {...styles.leftsectiomanager}>
                                            <Typography {...styles.branchdetailsheading}>
                                                {translate("Manager")}
                                            </Typography>
                                            <Typography {...styles.branchdetailscontent}>
                                                {translate(branchInfo.manager)}
                                            </Typography>

                                            <Typography {...styles.branchdetailscontentemail}>
                                                <a href={`mailto:${branchInfo.email}`} target="_self">
                                                    {branchInfo.email?.charAt(0)?.toUpperCase()}
                                                    {branchInfo.email?.slice(1)?.toLowerCase()}{" "}
                                                </a>
                                            </Typography>
                                        </GridItem>
                                    </GridItem>
                                ) : null}
                            </GridItem>
                        </GridItem>
                    </GridContainer>
                ) : (
                    <GridContainer>
                        <GridItem {...styles.unauthmaindiv}>
                            <Typography as="h2" {...styles.branchheading}>
                                {" "}
                                {translate("Search a Branch ")}
                            </Typography>
                            <GridItem {...styles.searchheadersectionunauth}>
                                <GridItem {...styles.postalcodeheadingunauth}>
                                    <TextField
                                        id="dealerLocatorViewAddressSearchField"
                                        label={translate("Zip/Postal Code or City, State/Province or Country")}
                                        required={true}
                                        value={searchGeoLocationFilter}
                                        onChange={handleSearchGeoLocationChanged}
                                        aria-hidden="true"
                                        placeholder={translate("Enter value here...")}
                                        data-test-selector="locationSearchForm_searchGeoLocation"
                                        error={showGeoLocationErrorMessage ? geoLocationErrorMessage : undefined}
                                    />
                                </GridItem>
                                <GridItem {...styles.searchbuttondivunauth}>
                                    <Button
                                        {...styles.searchbuttonstyle}
                                        type="submit"
                                        data-test-selector="locationSearchForm_searchButton"
                                    >
                                        {translate("Search")}
                                    </Button>
                                </GridItem>
                            </GridItem>
                        </GridItem>
                    </GridContainer>
                )}
            </Container>
        </StyledForm>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearchForm);
